import { CurrencyFormatter, RULES_EXCEPTIONS } from '../formatters/CurrencyFormatter';
import type { CurrencyInfo } from '../store/slices/game/types';

import { numberFormatterLocal } from './formatters';

export enum SeparatorChar {
  Decimal = '.',
  Group = ',',
}

const getPart = (parts: Intl.NumberFormatPart[], type: Intl.NumberFormatPartTypes): string[] => {
  return parts.filter((part) => part.type === type).map((part) => part.value);
};

const getFormatter = (locale: string, currency: string): Intl.NumberFormat => {
  try {
    return new Intl.NumberFormat(numberFormatterLocal(locale), {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
      ...RULES_EXCEPTIONS[currency],
    });
  } catch {
    return new Intl.NumberFormat(numberFormatterLocal(locale), {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 5,
    });
  }
};

// TODO: Ideally this info should be returned from the server
// TODO: not sure group group number is needed at all and is same in different locales
export const getCurrencyInfo = (currency: string, locale: string): CurrencyInfo => {
  const formatter = getFormatter(locale, currency);
  const parts = formatter.formatToParts(10000.12);

  const decimalSeparator = getPart(parts, 'decimal')[0] ?? SeparatorChar.Decimal;
  const groupSeparator = getPart(parts, 'group')[0] ?? SeparatorChar.Group;
  const decimals = getPart(parts, 'fraction')[0]?.length ?? 0;
  const groupNumber = getPart(parts, 'integer')[1]?.length ?? 0;
  const symbol = getPart(parts, 'currency')[0] ?? currency;

  return {
    digitsNumber: decimals,
    groupNumber,
    decimalSeparator,
    groupSeparator,
    symbol: CurrencyFormatter.replaceExceptionSymbol(symbol, currency),
  };
};
